import moment from "moment";
import { dateFormat } from "@bonliva-crm/locale";

/**
 * Checks if consultant is between 25 and 65 years old during the contract period
 * below25 and above65 are mutually exclusive
 * below25 means that the consultant is 24 or younger during the contract period
 * above65 means that the consultant is 66 or older during the contract period
 * becomes25 means that the consultant turns 25 during the contract period
 * becomes66 means that the consultant turns 66 during the contract period
 * is25To65 means that the consultant is between 25 and 65 during the contract period (inclusive)
 *
 * @param birthDate format: YYYY-MM-DD
 * @param startDate format: YYYY-MM-DD
 * @param endDate format: YYYY-MM-DD
 * @param minAge
 * @param maxAge
 */
export function ageIsWithinRangeDuringPeriod(
  birthDate: string,
  startDate: string,
  endDate: string,
  minAge: number,
  maxAge: number
): boolean {
  const consultantAgeAtContractStart = moment(startDate, dateFormat).diff(
    birthDate,
    "years"
  );
  const consultantAgeAtContractEnd = moment(endDate, dateFormat).diff(birthDate, "years");
  const consultantAgeAtContractStartIs25OrAbove = consultantAgeAtContractStart >= minAge;

  const consultantAgeAtContractEndIs65OrBelow = consultantAgeAtContractEnd <= maxAge;

  return consultantAgeAtContractStartIs25OrAbove && consultantAgeAtContractEndIs65OrBelow;
}

export function getConsultantAgeGroup(
  birthDate: string,
  startDate: string,
  endDate: string
) {
  const is25To64 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 25, 64);
  const is25To65 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 25, 65);
  const below25 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 0, 24);
  const above60 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 60, 200);
  const above64 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 65, 200);
  const above65 = ageIsWithinRangeDuringPeriod(birthDate, startDate, endDate, 66, 200);
  const becomes25 = moment(birthDate, dateFormat)
    .add(25, "years")
    .isBetween(startDate, endDate, "day", "(]");
  const becomes66 = moment(birthDate, dateFormat)
    .add(66, "years")
    .isBetween(startDate, endDate, "day", "(]");
  const becomes65 = moment(birthDate, dateFormat)
    .add(65, "years")
    .isBetween(startDate, endDate, "day", "(]");
  return {
    is25To65,
    is25To64,
    below25,
    above60,
    above64,
    above65,
    becomes25,
    becomes65,
    becomes66
  };
}
